import { createBrowserRouter, RouteObject } from "react-router"
import { LoginLayout } from "@/pages/Login/LoginLayout.tsx"
import { ResetPassword } from "@/pages/ResetPassword.tsx"
import { ErrorPage } from "@/pages/ErrorPage.tsx"
import { LoginForm } from "@/pages/Login/LoginForm.tsx"
import { RootLayout } from "@/router/layouts/RootLayout.tsx"
import { AppRoot } from "@/router/layouts/AppRoot.tsx"
import { app } from "@/router/app.tsx"

const login: RouteObject = {
  path: "login",
  Component: LoginLayout,
  children: [
    {
      index: true,
      Component: LoginForm,
    },
    {
      path: "resetPassword",
      Component: ResetPassword,
    },
  ],
}

export const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    ErrorBoundary: ErrorPage,
    children: [
      {
        index: true,
        Component: AppRoot,
      },
      login,
      app,
    ],
  },
])
